import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { ComumModule } from './../../../shared/comum.module';
import { RegionalCadastroComponent } from './regional-cadastro/regional-cadastro.component';
import { RegionalFiltroComponent } from './regional-filtro/regional-filtro.component';
import { RegionalListaComponent } from './regional-lista/regional-lista.component';
import { RegionalService } from './regional-service/regional.service';
import { RegionalComponent } from './regional.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule
  ],
  exports: [
    RegionalComponent
  ],
  declarations: [
    RegionalComponent,
    RegionalCadastroComponent,
    RegionalListaComponent,
    RegionalFiltroComponent
  ],
providers: [
  RegionalService
]
})
export class RegionalModule { }
